<template>
  <div id="bot-detection-page">
    <page-header-component v-if="topics" @filterChange="filterChange" :topics="topics" :hideValidate="true"
      :hideCakupan="false" icon="bi bi-exclamation-triangle" title="Deteksi Bot & Hoaks" />
    <transition name="block">
      <div class="row mb-4" v-if="mounted">
        <div class="col-6 px-gap">
          <div class="card shade card-default m-b-10" style="height: 100%">
            <div class="card-body">
              <h6>Jumlah Berita Berdasarkan Justifikasi</h6>
              <highcharts :options="configBar" :key="keyBar"></highcharts>
            </div>
          </div>
        </div>
        <div class="col-6 px-gap">
          <div class="card shade card-default m-b-10" style="height: 100%">
            <div class="card-body">
              <h6>Tren Justifikasi</h6>
              <highcharts :options="configLineDay" :key="keyBarLine"></highcharts>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <transition name="block">
      <div class="row mb-4" v-if="mounted">
        <div class="col-6 px-gap">
          <div class="card shade card-default m-b-10" style="height: 100%">
            <div class="card-body">
              <h6>Jumlah Akun Bot</h6>
              <!-- <bar-chart-component :dataset="dataBarBot_series.series" :y-label="dataBarBot_series.yLabel"
                barchart_id="media-cetak-barchart" /> -->
              <highcharts :options="configBar_bot" :key="keyBar_bot"></highcharts>
            </div>
          </div>
        </div>
        <div class="col-6 px-gap">
          <div class="card shade card-default m-b-10" style="height: 100%">
            <div class="card-body">
              <h6>Tren Akun Bot</h6>
              <!-- <line-chart-component :series="dataLineBot_series" height="400" el="linechart-tren-akun-bot" /> -->
              <highcharts :options="configLineDay_bot" :key="keyBarLine_bot"></highcharts>

            </div>
          </div>
        </div>
      </div>
    </transition>

  </div>
</template>

<script>
import moment from "moment";
import page_header from "@/views/components/page_header.vue";

// import bar_chart_highchart from "@/views/components/chart/bar_chart_highchart.vue";
// import line_chart from "@/views/components/chart/line_chart.vue";

import { Chart } from "highcharts-vue";
import Highcharts from "highcharts/highcharts.js";
import HighchartsMore from "highcharts/highcharts-more.js";
import { getTopicKeyword } from "@/models/topic.js";

HighchartsMore(Highcharts);

export default {
  name: "BotDetection",
  title: "Analitik Deteksi Bot & Hoaks | Sibernetik",
  components: {
    "page-header-component": page_header,
    // "bar-chart-component": bar_chart_highchart,
    // "line-chart-component": line_chart,
    highcharts: Chart,
  },
  is_clickable: {
    type: Boolean,
    default: function () {
      return true;
    },
  },
  data() {
    return {
      //
      dataBar: {},
      configBar: {},
      keyBar: 10,

      dataBar_bot: {},
      configBar_bot: {},
      keyBar_bot: 10,
      //
      dataLineDay: {},
      configLineDay: {},
      keyBarLine: 30,

      dataLineDay_bot: {},
      configLineDay_bot: {},
      keyBarLine_bot: 30,
      topics: null,
      id_project: this.$store.getters.user.id_project,
      mounted: false,
      categories: ['0%-25%', '26%-50%', '51%-75%', '76%-100%'],
    };
  },
  methods: {
    fetchDataBar: function () {
      var self = this;
      var params = this.$route.query;
      if ("from" in params == false) {
        params.from = this.$store.getters.filter_date_from.format(
          "YYYY-MM-DD HH:mm:ss"
        );
        params.to = this.$store.getters.filter_date_to.format(
          "YYYY-MM-DD HH:mm:ss"
        );
      }

      let query = Object.keys(params)
        .map((key) => key + "=" + params[key])
        .join("&");

      let api =
        process.env.VUE_APP_API_URL +
        "hoax/bar/" +
        this.id_project +
        "?" +
        query;

      this.$http
        .get(api)
        .then((resp) => {
          if (resp.status == 200) {
            this.dataBar = resp.data;
          }
        })
        .catch(function (err) {
          console.log(err);
        })
        .finally(function () {
          self.getDataBar();
        });
    },
    fetchDataLine: function () {
      var self = this;
      var params = this.$route.query;
      if ("from" in params == false) {
        params.from = this.$store.getters.filter_date_from.format(
          "YYYY-MM-DD HH:mm:ss"
        );
        params.to = this.$store.getters.filter_date_to.format(
          "YYYY-MM-DD HH:mm:ss"
        );
      }

      let query = Object.keys(params)
        .map((key) => key + "=" + params[key])
        .join("&");
      if ("q" in params) {
        params.q = atob(params.q);
      }
      let api =
        process.env.VUE_APP_API_URL +
        "hoax/line/" +
        this.id_project +
        "?" +
        query;
      this.$http
        .get(api)
        .then((resp) => {
          if (resp.status == 200) {
            this.dataLineDay = resp.data;
          }
        })
        .catch(function (err) {
          console.log(err);
        })
        .finally(function () {
          self.getDataBarLine();
        });
    },
    fetchDataBotBar: function () {
      var self = this;
      var params = this.$route.query;
      if ("from" in params == false) {
        params.from = this.$store.getters.filter_date_from.format(
          "YYYY-MM-DD HH:mm:ss"
        );
        params.to = this.$store.getters.filter_date_to.format(
          "YYYY-MM-DD HH:mm:ss"
        );
      }

      let query = Object.keys(params)
        .map((key) => key + "=" + params[key])
        .join("&");

      let api =
        process.env.VUE_APP_API_URL +
        "bot/bar/" +
        this.id_project +
        "?" +
        query;

      this.$http
        .get(api)
        .then((resp) => {
          if (resp.status == 200) {
            this.dataBar_bot = resp.data;
          }
        })
        .catch(function (err) {
          console.log(err);
        })
        .finally(function () {
          self.getDataBotBar();
        });
    },
    fetchDataBotLine: function () {
      var self = this;
      var params = this.$route.query;
      if ("from" in params == false) {
        params.from = this.$store.getters.filter_date_from.format(
          "YYYY-MM-DD HH:mm:ss"
        );
        params.to = this.$store.getters.filter_date_to.format(
          "YYYY-MM-DD HH:mm:ss"
        );
      }

      let query = Object.keys(params)
        .map((key) => key + "=" + params[key])
        .join("&");
      if ("q" in params) {
        params.q = atob(params.q);
      }
      let api =
        process.env.VUE_APP_API_URL +
        "bot/line/" +
        this.id_project +
        "?" +
        query;
      this.$http
        .get(api)
        .then((resp) => {
          if (resp.status == 200) {
            this.dataLineDay_bot = resp.data;
          }
        })
        .catch(function (err) {
          console.log(err);
        })
        .finally(function () {
          self.getDataBotLine();
        });
    },
    getDataBar: function () {
      let self = this;
      this.configBar = {
        chart: {
          type: "bar",
          backgroundColor: "transparent",
        },
        title: {
          text: "",
        },
        colors: [
          '#28A745',
          '#dc3444',
          '#7cb5ec',
          // '#7cb5ec'
        ],
        xAxis: {
          categories: this.dataBar.categories,
          title: {
            text: null,
          },
        },
        yAxis: {
          min: 0,
          labels: {
            overflow: "justify",
          },
          title: {
            text: "Jumlah Justifikasi",
          },
        },
        tooltip: {
          formatter: function () {
            var s =
              '<small>' + this.key + '</small><br>'
              + '<span>' + this.series.name + '</span> : '
              + Highcharts.numberFormat(this.point.y, 0, ',', ',')
            // + ' (' + Math.round(this.point.percentage) + '%)';
            return s;
          }
        },
        plotOptions: {
          bar: {
            dataLabels: {
              enabled: true,
              style: {
                textOutline: false
              },
              formatter: function() {
                return Highcharts.numberFormat(this.y, 0, ',', ',');
              },
            },
            colorByPoint: true
          },
          series: {
            cursor: 'pointer',
            events: {
              click: function (event) {
                let start = "";
                let end = "";
                let params = {};

                start = moment(self.$route.query.from).format(
                  "YYYY-MM-DD HH:mm:ss"
                );
                end = moment(self.$route.query.to).format(
                  "YYYY-MM-DD HH:mm:ss"
                );
                let hoak;
                if (event.point.category == "Fakta") {
                  hoak = btoa(1);
                  // } else if (event.point.category == "Tidak Diketahui") {
                  //   hoak = btoa(0);
                } else if (event.point.category == "Hoaks") {
                  hoak = btoa(-1);
                } else if (event.point.category == "Opini") {
                  hoak = btoa(2);
                }
                params = {
                  from: start,
                  to: end,
                  hoaxs: hoak,
                };
                self.$router.push({ path: "/hoax", query: params });

              },
            },
          }
        },
        credits: {
          enabled: false,
        },
        series: [
          {
            name: "Justifikasi",
            data: this.dataBar.series,
          },
        ],
      };
      this.keyBar++;
    },
    getDataBarLine: function () {
      let self = this;
      this.configLineDay = {
        chart: {
          type: "line",
          backgroundColor: "transparent",
        },
        tooltip: {
          formatter: function () {
            var s =
              '<small>' + this.key + '</small><br>'
              + '<span>' + this.series.name + '</span> : '
              + Highcharts.numberFormat(this.point.y, 0, ',', ',')
            // + ' (' + Math.round(this.point.percentage) + '%)';
            return s;
          }
        },
        title: {
          text: "",
        },
        xAxis: {
          categories: this.dataLineDay.date,
          title: {
            text: null,
          },
        },
        yAxis:{
          title: {
            text: null,
          },
        },
        plotOptions: {
          line: {
            dataLabels: {
              enabled: true,
              style: {
                textOutline: false
              },
              formatter: function() {
                return Highcharts.numberFormat(this.y, 0, ',', ',');
              },
            },
            enableMouseTracking: true,
          },
          series: {
            label: {
              connectorAllowed: false,
            },
            cursor: 'pointer',
            point: {
              events: {
                click: function (event) {
                  let start = "";
                  let end = "";
                  let params = {};

                  let tgl = event.point.category.split(" ");

                  let tgl_str = tgl[2] + "-" + tgl[1] + "-" + tgl[0];

                  tgl = moment(tgl_str, "YYYY-MMM-DD");

                  start = tgl.format("YYYY-MM-DD 00:00:00");
                  end = tgl.format("YYYY-MM-DD 23:59:59");

                  let hoak;
                  if (event.point.series.name == "Fakta") {
                    hoak = btoa(1);
                    // } else if (event.point.series.name == "Tidak Diketahui") {
                    //   hoak = btoa(0);
                  } else if (event.point.series.name == "Hoaks") {
                    hoak = btoa(-1);
                  } else if (event.point.series.name == "Opini") {
                    hoak = btoa(2);
                  }

                  params = {
                    from: start,
                    to: end,
                    hoaxs: hoak,
                  };
                  self.$router.push({ path: "/hoax", query: params });
                },
              },
            },
          },
        },
        credits: {
          enabled: false,
        },
        series: [
          {
            id: 1,
            name: "Fakta",
            data: this.dataLineDay.fakta,
            color: "#28a745",
          },
          // {
          //   id: 0,
          //   name: "Tidak Diketahui",
          //   data: this.dataLineDay.tdk_diket,
          //   color: "#ffc007",
          // },
          {
            id: -1,
            name: "Hoaks",
            data: this.dataLineDay.hoaks,
            color: "#dc3444",
          },
          {
            id: 2,
            name: "Opini",
            data: this.dataLineDay.opini,
            color: "#7cb5ec",
          },
        ],
      };
      this.keyBarLine++;
    },
    getDataBotBar: function () {
      let self = this;
      this.configBar_bot = {
        chart: {
          type: "bar",
          backgroundColor: "transparent",
        },
        title: {
          text: "",
        },
        colors: [
          '#28A745',
          '#ffc007',
          '#f17f28',
          '#dc3444',
        ],
        xAxis: {
          categories: this.categories,
          title: {
            text: null,
          },
        },
        yAxis: {
          min: 0,
          labels: {
            overflow: "justify",
          },
          title: {
            text: "Jumlah Justifikasi",
          },
        },
        tooltip:{
          formatter: function () {
            var s =
              '<small>' + this.key + '</small><br>'
              + '<span>' + this.series.name + '</span> : '
              + Highcharts.numberFormat(this.point.y, 0, ',', ',')
            // + ' (' + Math.round(this.point.percentage) + '%)';
            return s;
          }
        },
        plotOptions: {
          bar: {
            dataLabels: {
              enabled: true,
              style: {
                textOutline: false
              },
              formatter: function() {
                return Highcharts.numberFormat(this.y, 0, ',', ',');
              },
            },
            colorByPoint: true
          },
          series: {
            cursor: 'pointer',
            events: {
              click: function (event) {
                let start = "";
                let end = "";
                let params = {};

                start = moment(self.$route.query.from).format(
                  "YYYY-MM-DD HH:mm:ss"
                );
                end = moment(self.$route.query.to).format(
                  "YYYY-MM-DD HH:mm:ss"
                );
                let bot;
                if (event.point.category == "0%-25%") {
                  bot = btoa(25);
                } else if (event.point.category == "26%-50%") {
                  bot = btoa(50);
                } else if (event.point.category == "51%-75%") {
                  bot = btoa(75);
                } else if (event.point.category == "76%-100%") {
                  bot = btoa(100);
                }
                params = {
                  from: start,
                  to: end,
                  botscore: bot,
                };
                self.$router.push({ path: "/hoax", query: params });

              },
            },
          }
        },
        credits: {
          enabled: false,
        },
        series: [
          {
            name: "Deteksi Bot",
            data: this.dataBar_bot.series,
          },
        ],
      };
      this.keyBar++;
    },
    getDataBotLine: function () {
      let self = this;
      this.configLineDay_bot = {
        chart: {
          type: "line",
          backgroundColor: "transparent",
        },
        title: {
          text: "",
        },
        xAxis: {
          categories: this.dataLineDay_bot.date,
          title: {
            text: null,
          },
        },
        tooltip: {
          formatter: function () {
            var s =
              '<small>' + this.key + '</small><br>'
              + '<span>' + this.series.name + '</span> : '
              + Highcharts.numberFormat(this.point.y, 0, ',', ',')
            // + ' (' + Math.round(this.point.percentage) + '%)';
            return s;
          }
        },
        yAxis:{
          title: {
            text: null,
          },
        },
        plotOptions: {
          line: {
            dataLabels: {
              enabled: true,
              style: {
                textOutline: false
              },
              formatter: function() {
                return Highcharts.numberFormat(this.y, 0, ',', ',');
              },
            },
            enableMouseTracking: true,
          },
          series: {
            label: {
              connectorAllowed: false,
            },
            cursor: 'pointer',
            point: {
              events: {
                click: function (event) {
                  let start = "";
                  let end = "";
                  let params = {};

                  let tgl = event.point.category.split(" ");

                  let tgl_str = tgl[2] + "-" + tgl[1] + "-" + tgl[0];

                  tgl = moment(tgl_str, "YYYY-MMM-DD");

                  start = tgl.format("YYYY-MM-DD 00:00:00");
                  end = tgl.format("YYYY-MM-DD 23:59:59");

                  let bot;
                  if (event.point.series.name == "0%-25%") {
                    bot = btoa(1);
                  } else if (event.point.series.name == "26%-50%") {
                    bot = btoa(2);
                  } else if (event.point.series.name == "51%-75%") {
                    bot = btoa(3);
                  } else if (event.point.series.name == "76%-100%") {
                    bot = btoa(4);
                  }
                  params = {
                    from: start,
                    to: end,
                    botscore: bot,
                  };
                  self.$router.push({ path: "/hoax", query: params });
                },
              },
            },
          },
        },
        credits: {
          enabled: false,
        },
        series: [
          {
            id: 1,
            name: "0%-25%",
            data: this.dataLineDay_bot.satu,
            color: "#28A745",
          },
          {
            id: 0,
            name: "26%-50%",
            data: this.dataLineDay_bot.dua,
            color: "#ffc007",
          },
          {
            id: -1,
            name: "51%-75%",
            data: this.dataLineDay_bot.tiga,
            color: "#f17f28",
          },
          {
            id: 2,
            name: "76%-100%",
            data: this.dataLineDay_bot.empat,
            color: '#dc3444',
          },
        ],
      };
      this.keyBarLine++;
    },
    getTopic: function () {
      var self = this;
      let api = process.env.VUE_APP_API_URL + "list-topics/" + this.id_project;
      this.$http
        .get(api)
        .then(function (response) {
          if (response.status == 204) {
            self.topics = {};
          } else {
            self.topics = response.data;
          }
        })
        .catch(function () {
          self.topics = {};
        })
        .finally(() => {
          this.fetchDataBar();
          this.fetchDataBotBar();
          this.fetchDataLine();
          this.fetchDataBotLine();
        });
    },
    filterChange: function () {
      var params = this.$route.query;
      if ("day" in params) {
        delete params.day;
        let current_path = this.$route.path;
        this.$router
          .replace(current_path)
          .then(this.$router.replace({ query: params }));
      }
      if ("hash" in this.$route) {
        if (this.$route.hash != "") {
          params.q = this.$route.hash.replace("#", "");
          params.page = 1;
          this.$router.replace({ query: params });
        }
      }
      let query = Object.keys(params)
        .map((key) => key + "=" + params[key])
        .join("&");

      if (this.query != query) {
        this.isLoading = true;
        this.data_from = this.$route.query.from;
        this.data_to = this.$route.query.to;
        this.getTopic();
      }
    },
  },
  mounted: function () {
    this.fetchDataBar();
    this.fetchDataBotBar();
    this.fetchDataLine();
    this.fetchDataBotLine();
    this.mounted = true;
  },
  watch: {
    $route() {
      this.fetchDataBar();
      this.fetchDataBotBar();
      this.fetchDataLine();
      this.fetchDataBotLine();
    },
  },
  created: async function () {
    this.topic_keyword = await getTopicKeyword(
      this.$store.getters.user.id_project
    );
    this.getTopic();
  },
};
</script>
